var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M24 65h2V37h-2zM54 65h2V37h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 72c-.118 0-.237-.021-.352-.063l-15.636-5.865-14.641 5.857a1.002 1.002 0 01-.742 0l-14.641-5.857-15.636 5.865A1 1 0 018 71V43c0-.417.259-.79.648-.937l16-6c.234-.086.492-.084.723.008l5 2-.742 1.858-4.641-1.857L10 43.693v25.864l14.648-5.494c.234-.085.492-.085.723.008L40 69.923l14.629-5.852c.232-.092.49-.093.723-.008L70 69.557V43.693l-14.988-5.621-4.641 1.857-.742-1.858 5-2c.232-.092.49-.093.723-.008l16 6c.389.147.648.52.648.937v28a1 1 0 01-1 1",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 10c-6.617 0-12 5.383-12 12 0 5.765 9.187 19.274 12 23.276C42.813 41.274 52 27.765 52 22c0-6.617-5.383-12-12-12zm0 38a.998.998 0 01-.808-.411C38.653 46.851 26 29.42 26 22c0-7.72 6.28-14 14-14s14 6.28 14 14c0 7.42-12.653 24.851-13.192 25.589A.998.998 0 0140 48z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M39 71h2v-9h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 16c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zm0 14c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M39 52h2v-2h-2zM39 56h2v-2h-2zM39 60h2v-2h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationMap;